import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules,
  state: {
    drawer: true,
    loading: false,
    role: localStorage.getItem('role'),
    name: localStorage.getItem('name'),
    roleName: localStorage.getItem('roleName'),
    mapDoorphones: [],
    redirectAfterLogin: null,
    userId: localStorage.getItem('userId'),
  },
  getters: {
    drawer (state) {
      return state.drawer;
    },
    loading (state) {
      return state.loading;
    },
    role (state) {
      return state.role;
    },
    name (state) {
      return state.name;
    },
    roleName (state) {
      return state.roleName;
    },
    userId (state) {
      return state.userId;
    },
  },
  mutations: {
    setDrawer (state, payload) {
      state.drawer = payload;
    },
    setLoading (state, payload) {
      state.loading = payload;
    },
    setRole (state, payload) {
      state.role = payload;
    },
    setName (state, payload) {
      state.name = payload;
    },
    setRoleName (state, payload) {
      state.roleName = payload;
    },
    setLogout (state, payload) {
      state.role = '';
      state.name = '';
      state.roleName = null;
      state.userId = null;
    },
    setUserId (state, payload) {
      state.userId = payload;
    },
    setRedirectAfterLogin (state, path) {
      state.redirectAfterLogin = path;
    },
    clearRedirectAfterLogin (state) {
      state.redirectAfterLogin = null;
    },
    addDoorphone (state, newMarker) {
      if (newMarker.type === 'B') {
        state.Doorphone.mapDoorphones.barriers.push(newMarker);
      } else {
        state.Doorphone.mapDoorphones.doorphones.push(newMarker);
      }
    },
    removeMarker (state, markerGeneral) {
      let collection;
      if (markerGeneral.type === 'B') {
        collection = state.Doorphone.mapDoorphones.barriers;
      } else {
        collection = state.Doorphone.mapDoorphones.doorphones;
      }

      const index = collection.findIndex(marker => marker.id === markerGeneral.id);
      if (index !== -1) {
        collection.splice(index, 1);
      }
    },
  },
  actions: {
    saveRedirectAfterLogin ({ commit }, path) {
      commit('setRedirectAfterLogin', path);
    },
    clearRedirect ({ commit }) {
      commit('clearRedirectAfterLogin');
    },
  },
  strict: debug,
});
